<form
  #userForm="ngForm"
  id="forms.userForm"
  role="form"
  name="forms.userForm"
  autocomplete="on"
  (submit)="save()"
  novalidate
>
  <div
    rvSpinner="user-settings"
    [rvShowSpinner]="loading"
    class="settings-page-container"
    role="main"
  >
    <div class="settings-page-body">
      <div id="user-settings">
        <user-fields [user]="user" [actions]="pageActions"></user-fields>
        <div
          id="errorBox"
          class="alert alert-danger tw-mt-2.5"
          role="alert"
          [shown]="formError"
        >
          <strong>{{ formError }}</strong> {{ apiError }}
        </div>
      </div>
    </div>
    <div class="settings-page-footer">
      <common-actions
        [actions]="actions"
        [saving]="loading"
        [changeDate]="user.changeDate"
        [changedBy]="user.changedBy"
      >
      </common-actions>
    </div>
  </div>
</form>
